import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { APIService } from '../../services/client/api/api.service';
import { AnswersRepositoryService } from '../../services/answers-repository.service';
import { Category, Question } from 'src/app/services/client';
import { AnswerByCategory } from '../../services/client/model/answerByCategory';
import { QuestionAnswer } from '../../services/client/model/questionAnswer';
import { Subscription } from 'rxjs';
import { RoutesManagerService } from '../../services/routes-manager.service';

@Component({
  selector: 'app-finalization',
  templateUrl: './finalization.component.html',
  styleUrls: ['./finalization.component.css']
})
export class FinalizationComponent implements OnDestroy {

  finalComments = '';
  category: Category;
  question: Question;
  error = false;
  loading = false;
  subscription: Subscription;
  subscriptionCategory: Subscription;
  subscriptionQuestion: Subscription;

  constructor(private router: Router, private apiService: APIService, private answersRepository: AnswersRepositoryService, private routesManager: RoutesManagerService) {
    this.getLastCategory();
  }
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscriptionCategory) {
      this.subscriptionCategory.unsubscribe();
    }
    if (this.subscriptionQuestion) {
      this.subscriptionQuestion.unsubscribe();
    }
  }

  saveChanges() {
    this.answersRepository.finalComments = this.finalComments;
    const categoryAnswer: QuestionAnswer = {
      question_id: this.question.id,
      option_value: 0,
    };
    const finalAnswer: AnswerByCategory = {
      category_id: this.category.id,
      category_answers: [categoryAnswer],
      observation: this.finalComments
    };
    this.answersRepository.addAnswer(finalAnswer);
    this.loading = true;
    this.subscription = this.answersRepository.postAnswer().subscribe(
      (response) => {
        if (response.status === 200) {
          this.routesManager.setLocalRouteValue('completada');
          this.router.navigate(['completada']);
        }
        else {
          this.error = true;
          this.loading = false;
        }
      },
      () => {
        this.error = true;
        this.loading = false;
      }
    );
  }

  getLastCategory() {
    this.subscriptionCategory = this.apiService.categoriesGet().subscribe(
      categories => {
        this.category = categories[categories.length - 1];
        this.getLastQuestion();
      },
      () => {
        this.loading = false;
        this.error = true;
      }
    );
  }

  getLastQuestion() {
    this.subscriptionQuestion = this.apiService.categoryCategoryIdQuestionsGet(this.category.id).subscribe(
      questions => {
        this.question = questions[0];
      },
      () => {
        this.loading = false;
        this.error = true;
      }
    );
  }

}
